// extracted by mini-css-extract-plugin
export default {"inputBox":"StopSelect_inputBox__qllT0","button":"StopSelect_button__o0qBo","svgIcon":"StopSelect_svgIcon__G2vbT"};